import React from "react";
import styles from "@/components/LanguageModelArtifact/style.module.css";
export const ProgressBar = ({ value }) => {
    const width = `${Math.min(Math.max(value, 0.01), 100)}%`;
    return (React.createElement("div", { className: styles.progressWrapper },
        React.createElement("div", { style: {
                width: width,
                height: "20px",
                backgroundColor: "#BBADFB"
            } })));
};
